// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"b8bcfacf","246":"6154f377","313":"48d1a5ed","377":"58e8b68f","547":"6ad8a9ef","631":"93c3803b","783":"846afc3c"}[chunkId] + ".chunk.js";
};